export default {
	data: () => ({
		el_footer:false,
	}),
	methods: {
		
	}
}